import { render, staticRenderFns } from "./DeliveryListItem.vue?vue&type=template&id=75e16408"
import script from "./DeliveryListItem.vue?vue&type=script&lang=js"
export * from "./DeliveryListItem.vue?vue&type=script&lang=js"
import style0 from "./DeliveryListItem.vue?vue&type=style&index=0&id=75e16408&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports